<template>

    <v-layout row  mb-3 class="issue-line">

        <v-flex xs2 md1 class="id-block" > 
            <v-layout column>

                <v-flex class="username-truncate"
                    @click="viewDetail(user)">
                    {{user.userName }}
                </v-flex>

            </v-layout>
        </v-flex>
        <v-flex xs10 md10 class="info-block">
            <v-layout row wrap>
                <v-flex xs8 md8>
                    <v-layout column>
                        <v-flex class="email-truncate" >
                            {{user.email }}
                        </v-flex>
                        <v-flex class="text-medium">
                            {{user.userType }}
                        </v-flex>
                        <v-flex class="text-medium">
                            {{user.id }}
                        </v-flex>

                    </v-layout>
                </v-flex>
                <v-flex xs4 md4 class="dept-block">
                    <v-layout column>
                        <v-flex >
                            {{user.brand }}
                        </v-flex>
                        <v-flex class="text-medium">
                            {{user.department }}
                        </v-flex>
                        <v-flex class="text-medium">
                            {{user.section }}
                        </v-flex>

                    </v-layout>
                </v-flex>

            </v-layout>
        </v-flex>

    </v-layout>

</template>
<script>

export default {
    props:['user'],
    data(){
        return {
            minDate:new Date('1/1/2020')
        }
    },
    computed:{
    },
    methods:{
        viewDetail(user){
            //console.log("issue",issue)
            this.$emit('clickUser',user)
        },

    },
    mounted(){
        //console.log("UserLine mounted")
    }
}
</script>
<style scoped>
.id-block{
    min-width: 150px;
    max-width: 150px;
}

.dept-block{
    min-width: 150px;
    max-width: 150px;
    text-align: left;
}

.user-line{
    padding-top: 8px;
    padding-left: 3px;
    list-style-type: none;
    background: white;
    border-radius: 10px;
    box-shadow: 1px 1px 4px rgba(0,0,0,0.1);

}
.truncate {
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.username-truncate {
    font-weight: bold;
    background-color: orange;
    width: 130px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    padding: 5px;
    border-radius: 5px;
    cursor: pointer;
}
.email-truncate {
  width: 250px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.text-small{
    padding-left: 3px;
    font-size: 0.75rem;
}
.text-medium{
    font-size: 0.85rem;
    font-style: italic;
}
.text-bold{
    font-weight: bold;
    font-size: 1.1rem;
}

</style>